import styled from "styled-components";
import colors from "../../../../../../../../core/styles/colors";
import {
  InfoPageContent,
  InfoPageTextInfo,
} from "../../../../../../../shared/infoPage/infoPage.styles";

export const OfflineInfoPageContent = styled(InfoPageContent)`
  max-width: 640px;
`;

export const OfflineInfoText = styled(InfoPageTextInfo)`
  .strongWord {
    font-size: 20px;
  }
  p {
    margin: 0;
    text-align: center;
    font-family: "Proxima Nova Lt", serif;
    font-size: 18px;
    line-height: 28px;
  }
  .linkWord {
    color: ${colors.blue.general};
    text-decoration: underline;
  }
`;
